import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-kopieren';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenAufgabeKopierenEffects {

    AufgabeKopieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_KOPIEREN),
        mergeMap((x: ac.PostAufgabeKopierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeKopieren(x.aufgabeRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeKopierenErfolgreichAction(result, x.aufgabeRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeKopierenFehlerAction(error, x.aufgabeRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
